import { apiGet, apiPut } from "./helpers/api";
import { normalize, schema } from "normalizr";

const notificationSchema = new schema.Entity("notifications");
const notificationsUserSchema = new schema.Entity("notificationsUsers", {
  meta: {
    notification: notificationSchema,
  },
});

export const notificationsUserFetched = (dispatch, notificationUser) =>
  dispatch({
    type: "NOTIFICATIONS_USER_FETCHED",
    ...normalize(notificationUser, notificationsUserSchema),
  });

/** Fetch all notifications (high per_page) — used by sidebar for unread count */
export const fetchNotificationsUsers = (dispatch) => {
  return apiGet("/api/v1/notifications_users?per_page=999").then(
    (response) => {
      const data = response.body.data ?? response.body;
      dispatch({
        type: "NOTIFICATIONS_USERS_FETCHED",
        ...normalize(
          Array.isArray(data) ? data : [],
          new schema.Array(notificationsUserSchema)
        ),
      });
    }
  );
};

/** Fetch a specific page — used by the notifications page.
 *  Returns pagination info + the notification IDs for this page only. */
export const fetchNotificationsUsersPage = (dispatch, page = 1, perPage = 15) => {
  return apiGet(`/api/v1/notifications_users?page=${page}&per_page=${perPage}`).then(
    (response) => {
      const data = response.body.data ?? response.body;
      const items = Array.isArray(data) ? data : [];
      const normalized = normalize(items, new schema.Array(notificationsUserSchema));
      dispatch({ type: "NOTIFICATIONS_USERS_PAGE_FETCHED", ...normalized });

      // Extract the notification IDs that belong to this page
      // Coerce to number to match the IDs from getAllNotifications selector
      const pageNotificationIds = items
        .map((item) => {
          const raw = item.meta?.notification?.id ?? item.notificationId;
          return raw != null ? Number(raw) : null;
        })
        .filter((id) => id != null);

      return {
        totalPages: response.body.totalPages || 1,
        currentPage: response.body.currentPage || 1,
        totalCount: response.body.totalCount || 0,
        pageNotificationIds,
      };
    }
  );
};

export const readAllNotifications = (dispatch) => {
  return apiPut("/api/v1/notifications_users/read").then(() => {
    return fetchNotificationsUsers(dispatch);
  });
};

export const readNotification = (dispatch, notificationsUserId) => {
  return apiPut(`/api/v1/notifications_users/${notificationsUserId}`).then(
    (response) => {
      const data = response.body.data ?? response.body;
      dispatch({
        type: "NOTIFICATIONS_USER_FETCHED",
        ...normalize(data, notificationsUserSchema),
      });
    }
  );
};

export const unreadNotification = (dispatch, notificationsUserId) => {
  return apiPut(`/api/v1/notifications_users/${notificationsUserId}/unread`).then(
    (response) => {
      const data = response.body.data ?? response.body;
      dispatch({
        type: "NOTIFICATIONS_USER_FETCHED",
        ...normalize(data, notificationsUserSchema),
      });
    }
  );
};
